import React, { useContext, useEffect } from 'react'
import {Link} from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import HomeRedirectLogo from './homeRedirectLogo.svg'
import LogoutLogo from './logout.svg'
import Logo from './Medi-Cal_Rx-logo.png'

import {faUserMd} from '@fortawesome/free-solid-svg-icons'

import messages from "./utils";

import useStyles from "./styles";
import AppContext from "../../contexts/App/App.context";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getHomeUrl, getContactUrl} from '../../shared/okta.helper'
import { Typography } from '@material-ui/core'

export default function Header() {

    // Google Translate API - Known timing issue between Google Translate API and React causing component not to load on 1st attempt when using script in index.html.
    useEffect(() => {
        const addGoogleTranslateScript = () => {
            if (document.getElementById("google-translate-script")) return;
            
            const script = document.createElement("script");
            script.id = "google-translate-script"
            script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            document.body.appendChild(script);
        }

        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement(
                {
                    pageLanguage: 'en'
                },
                'google_translate_element'
            );
        };
        
        addGoogleTranslateScript();
    }, []);

    const classes = useStyles()
    const {provider, npiNumber, isLoggedIn, logout} = useContext(AppContext);
    const {id, navBars, caLogo} = messages
    return (
        <header id={id} data-testid={id}>

            <div className={classes.root}>

                <Grid container className={classes.headerTop} >
                    <Grid
                        item xs={12}
                        container
                        className={classes.headerTypography}
                    >
                        { isLoggedIn() &&
                            <>
                                <Grid item className={classes.homeLinkWrapper}>
                                    <span>
                                        <img src={HomeRedirectLogo} alt='Main Portal' className={classes.homeRedirectIcon} />
                                        <a className={classes.homeLink} href={getHomeUrl()}>Back to Dashboard</a>
                                    </span>
                                </Grid>
                                <Grid item>
                                    <span id="MEDCAL_RX_NAV_PERSON_ICON" data-testid="MEDCAL_RX_NAV_PERSON_ICON">
                                    <FontAwesomeIcon icon={faUserMd} className={classes.personaIcon}/>
                                    </span>
                                </Grid>
                                <Grid item className={classes.npiWrapper}>
                                    { provider &&
                                        <span
                                            className={classes.npi}
                                            id="MEDCAL_RX_NAV_USERNAME"
                                            data-testid="MEDCAL_RX_NAV_USERNAME"
                                        >
                                            {`${provider.providerFirstName ? provider.providerFirstName : ''}${provider.providerFirstName ? ' ' : ''}${provider.providerLastName ? provider.providerLastName : ''}`}
                                        </span>
                                    }
                                    {npiNumber && <span className={classes.npi} id="MEDCAL_RX_NAV_NPI" data-testid="MEDCAL_RX_NAV_NPI"> (NPI:{npiNumber})</span>}
                                </Grid>

                            </>
                        }
                        <Grid item className={classes.contactLinkWrapper}>
                            <a href={getContactUrl()} id="MEDCAL_RX_NAV_CONTACT_LINK" data-testid="MEDCAL_RX_NAV_CONTACT_LINK" className={classes.contactLink}>
                                Contact Us
                            </a>
                        </Grid>
                        <Grid item>
                            <div className={classes.langWrapper} id="MEDCAL_RX_GOOGLE_TRANSLATE" data-testid="MEDCAL_RX_GOOGLE_TRANSLATE">
                                <div id="google_translate_element"></div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container className={classes.headerBottom}>
                    <Grid item className={classes.headerBottomDHCSLogo}>
                        <div id={caLogo.id} className={classes.caLogo}>
                            <Link to='/'>
                                <img src={Logo} alt={caLogo.text} className={classes.dhcsLogo}/>
                            </Link>
                        </div>
                    </Grid>
                    <Grid item className={classes.headerBottomNavLinksWrapper}>
                        <Grid
                            container
                            className={classes.headerBottomNavLinksContent}>
                                {isLoggedIn() &&
                                <Button
                                    onClick={logout}
                                    disableRipple
                                    className={classes.logoutButton}>
                                        <img src={LogoutLogo} alt="Logout Icon" className={classes.logoutIcon}/>
                                        <Typography variant='caption' className={classes.logoutLabel}>{navBars.bottom.logout.text}</Typography>
                                </Button>
                                }
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </header>
    )
}
